import { SnackbarProvider } from "notistack";
import SuccessSnackbar from "./customSnackbars/successSnackbar/successSnackbar";
import StyledMaterialDesignContent from "./StyledMaterialDesignContent";
import CssBaseline from "@mui/material/CssBaseline";
import Notifier from "../../molecules/notifier";

// Provide a custom styled snackbar
const CustomSnackbarProvider = ({ children }) => {
  return (
    <SnackbarProvider
      maxSnack={1}
      preventDuplicate={true}
      autoHideDuration={3000}
      anchorOrigin={{ horizontal: "right", vertical: "top" }}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        customSuccess: SuccessSnackbar,
      }}
    >
      <CssBaseline />
      <Notifier />
      {children}
    </SnackbarProvider>
  );
};

export default CustomSnackbarProvider;
